// frontend/src/hooks/useLocations.js
import { useState, useCallback, useEffect } from 'react';
import { fetchLocationsAPI, addLocationAPI, updateLocationAPI, deleteLocationAPI } from '../services/api';
import { useAuth } from './useAuth'; // Importiere useAuth

export const useLocations = () => {
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { handleApiError } = useAuth(); // Nutze handleApiError vom Auth Hook

  const fetchLocations = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await fetchLocationsAPI();
      setLocations(data);
    } catch (err) {
      handleApiError(err); // Fehlerbehandlung über useAuth
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, [handleApiError]); // Abhängigkeit von handleApiError

  const addLocation = useCallback(async (locationData) => {
    setError(null);
    try {
      const newLocation = await addLocationAPI(locationData);
      setLocations(prev => [...prev, newLocation]);
      return true; // Erfolg signalisieren
    } catch (err) {
      handleApiError(err);
      setError(err.message);
      return false; // Misserfolg signalisieren
    }
  }, [handleApiError]);

  const updateLocation = useCallback(async (id, locationData) => {
    setError(null);
    try {
      const updatedLocation = await updateLocationAPI(id, locationData);
      setLocations(prev => prev.map(loc => loc._id === id ? updatedLocation : loc));
      return true;
    } catch (err) {
      handleApiError(err);
      setError(err.message);
      return false;
    }
  }, [handleApiError]);

  const deleteLocation = useCallback(async (id) => {
    setError(null);
    try {
      await deleteLocationAPI(id);
      setLocations(prev => prev.filter(loc => loc._id !== id));
      return true;
    } catch (err) {
      handleApiError(err);
      setError(err.message);
      return false;
    }
  }, [handleApiError]);

  // Optional: Initiales Laden beim Mounten des Hooks
  // useEffect(() => {
  //   fetchLocations();
  // }, [fetchLocations]);

  return { locations, isLoading, error, fetchLocations, addLocation, updateLocation, deleteLocation };
};
